import React, { FC } from "react";
import { useSelector } from "react-redux";

import AdGroupsDashboard from "../components/AdGroupsDashboard";
import Button from "../../../../components/elements/Button";
import TabPanel from "../../../../components/elements/TabPanel";
import classes from "../AdGroupSelectionSlide.module.scss";
import { AdGroupToCreateType } from "../../../../types/campaignTypes";
import { PageStepComponentProps } from "../../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../../types/ReduxTypes/ReduxApplicationState";

type SelectSavedAdGroupTabProps = {
  selectedTabPanelValue: number;
  updateAdGroup?: (values: AdGroupToCreateType, createAdGroup?: boolean) => void;
  showCheckbox?: boolean;
  showSubmitButton?: boolean;
};

const SelectSavedAdGroupTab: FC<PageStepComponentProps & SelectSavedAdGroupTabProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
  selectedTabPanelValue,
  updateAdGroup,
  showCheckbox = true,
  showSubmitButton = false,
}) => {
  const selectedAdvertiser = useSelector((state: ReduxApplicationState) => state.campaignToCreate.selectedAdvertiser)!;
  const adGroupToCreate = useSelector((state: ReduxApplicationState) => state.campaignToCreate.adGroupToCreate);

  const isVideoCampaign = useSelector(
    (state: ReduxApplicationState) => state.campaignToCreate.basicDetails.isVideoCampaign,
  );

  return (
    <TabPanel
      value={selectedTabPanelValue}
      index={0}
      id="adGroup-selection-tabpanel"
      ariaLabelledBy="adGroup-selection-tab"
      className={classes.adGroupSelectionTabpanel}
    >
      <AdGroupsDashboard
        selectedAdvertiser={selectedAdvertiser}
        isAttemptingToGoNext={isAttemptingToGoNext}
        setIsAttemptingToGoNext={setIsAttemptingToGoNext}
        handleNext={handleNext}
        showCheckbox={showCheckbox}
        isVideoCampaign={isVideoCampaign}
      />
      {showSubmitButton && (
        <Button
          className={classes.submitSavedAdGroupBtn}
          onClick={() => {
            if (updateAdGroup) {
              updateAdGroup(adGroupToCreate, false);
            }
          }}
        >
          Submit
        </Button>
      )}
    </TabPanel>
  );
};

export default SelectSavedAdGroupTab;
